import _ from 'lodash';
import Tooltip from '@material-ui/core/Tooltip';
import Image from 'components/Image';

const Colors = ({ product, onChange, colors = [] }) => (
  <div>
    {product?.Colors?.map((color) => {
      const isExist = !!_.find(colors, (c) => c?.ID === color?.ID);

      return color?.visible === false ? null : (
        <Tooltip title={color?.Name} key={`Colors${color.ID}`}>
          <div>
            <Image
              imageStyle={
                isExist
                  ? { border: '2px solid green', width: 'auto', height: '100%' }
                  : { width: 'auto', height: '100%' }
              }
              src={color?.Image}
              key={`Colors${color.ID}`}
              alt={color?.Name}
              onClick={() => {
                if (!isExist) {
                  const value = [...colors, color];
                  onChange(value);
                } else {
                  const filterData = _.filter(colors, (c) => c.ID !== color.ID);
                  onChange(filterData);
                }
              }}
            />
          </div>
        </Tooltip>
      );
    })}
  </div>
);

export default Colors;
